// Протокол измерений толщины стенки замкнутых элементов (1,3,4 вкладка готовы)
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  CCard,
  CCardBody,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CButton,
  CFormTextarea,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CFormInput,
  CFormSelect,
  CSpinner,
  CInputGroup
} from "@coreui/react";
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import PhotoTab from './Tabs/PhotoTab';

const ProtocolThickness = ({ ldoc, nvalue, activeProtocolId, refreshProtocols }) => {
  const [activeKey, setActiveKey] = useState(1);
  const [groupedData, setGroupedData] = useState({});
  const [normativeDocs, setNormativeDocs] = useState([]);
  const [measurementToolsOptions, setMeasurementToolsOptions] = useState([]);
  const [measurementConductedByOptions, setMeasurementConductedByOptions] = useState([]);
  const [developedByOptions, setDevelopedByOptions] = useState([]);
  const [normativeDocsList, setNormativeDocsList] = useState([]);
  const [measurementToolsList, setMeasurementToolsList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [dateMeasurement, setDateMeasurement] = useState("");
  const [dateProtocol, setDateProtocol] = useState("");
  const [newProtocolId, setNewProtocolId] = useState(null);
  const [photoTabProtocolId, setPhotoTabProtocolId] = useState(null);
  const [selectedNormativeDoc, setSelectedNormativeDoc] = useState('');
  const [selectedMeasurementTool, setSelectedMeasurementTool] = useState('');
  const [selectedConductedBy, setSelectedConductedBy] = useState('');
  const [selectedDevelopedBy, setSelectedDevelopedBy] = useState('');
  // --- Вкладка 3: Вывод ---
  const [conclusion, setConclusion] = useState("");
  // --- Вкладка 3: Вывод ---
  const [isLoading, setIsLoading] = useState(false);
  
  // Новые состояния для второй вкладки
  const [projectThickness, setProjectThickness] = useState('');
  const [gostValue, setGostValue] = useState('');
  const [projectValue, setProjectValue] = useState('');
  const [tableData, setTableData] = useState([
    // Пример данных таблицы
    // { id: 1, sectionNumber: '1', elementName: 'Пояс', measuredThickness: '10.2', deviation: '-2.5' }
  ]);

  const token = localStorage.getItem("token");
  const getIdByName = (name, list) => {
    if (!name || !list || !Array.isArray(list)) return null;
    const item = list.find((item) => item.name === name);
    return item ? item.Id : null;
  };
  function formatDateToISO(originalDate) {
    if (!originalDate) return "";
    const parts = originalDate.split('.');
    if (parts.length !== 3) return "";
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  useEffect(() => {
    setPhotoTabProtocolId(activeProtocolId || newProtocolId || null);
  }, [activeProtocolId, newProtocolId]);
  useEffect(() => {
    if (ldoc && nvalue !== null) {
      setIsLoading(true);
      const loadProtocolInfo = () => {
        return axios.get(`/api/ldoc/${ldoc}/protocol-info/${nvalue}/`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then((response) => {
          const result = response.data.data || [];
          const grouped = {};
          const normativeList = [];
          const measurementToolsListTemp = [];
          const peopleListTemp = [];
          const developedByList = [];
          const normativeDocsListTemp = [];
          const measurementToolsListWithId = [];
          const peopleListWithId = [];
          result.forEach((item) => {
            const key = item[""]?.trim();
            const value = item.ObjName;
            if (!key) return;
            switch (key) {
              case "Нормативные документы":
                if (value) {
                  normativeList.push(value);
                  normativeDocsListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Средства измерений":
                if (value) {
                  measurementToolsListTemp.push(value);
                  measurementToolsListWithId.push({ Id: item.Id, name: value });
                }
                break;
              case "Измерения проводил":
                if (value) {
                  peopleListTemp.push({ Id: item.Id, name: value });
                }
                break;
              case "Разработал":
                if (value) {
                  developedByList.push(value);
                }
                break;
              default:
                if (key !== "Выводить значения") {
                  grouped[key] = value;
                }
            }
          });
          setNormativeDocsList(normativeDocsListTemp);
          setMeasurementToolsList(measurementToolsListWithId);
          setPeopleList(peopleListWithId);
          setGroupedData(grouped);
          setNormativeDocs(normativeList);
          setMeasurementToolsOptions(measurementToolsListTemp);
          setMeasurementConductedByOptions(peopleListTemp.map(p => p.name));
          setDevelopedByOptions(developedByList);
          setSelectedNormativeDoc(normativeList[0] || "");
          setSelectedMeasurementTool(measurementToolsListTemp[0] || "");
          setSelectedConductedBy(peopleListTemp.length > 0 ? peopleListTemp[0].name : "");
          setSelectedDevelopedBy(developedByList[0] || "");
          setDateMeasurement(grouped["Дата проведения измерений"] || "");
          setDateProtocol(grouped["Дата протокола"] || "");
        });
      };
      const loadProtocolDetails = () => {
         if (activeProtocolId) {
            return axios.get(`/api/protocol-details/${activeProtocolId}/`, {
              headers: { Authorization: `Bearer ${token}` },
            }).then(response => {
                const data = response.data.data;
                if (data && data.length >= 10) {
                  setSelectedNormativeDoc(data[3]?.Value || "");
                  setSelectedMeasurementTool(data[4]?.Value || "");
                  setSelectedConductedBy(data[5]?.Value || (measurementConductedByOptions[0] || ""));
                  // --- Загрузка Вывода ---
                  setConclusion(data[9]?.Value || ""); // Предполагаем индекс 9 для Conclusion
                  // --- Загрузка Вывода ---
                  setDateMeasurement(formatDateToISO(data[7]?.Value) || "");
                  setDateProtocol(formatDateToISO(data[8]?.Value) || "");
                  setSelectedDevelopedBy(data[6]?.Value || (developedByOptions[0] || ""));
                }
            }).catch((error) => {
                console.error("Ошибка загрузки данных protocol-details:", error);
                // Не блокируем работу, если детали не загрузились
            });
         } else {
             // Если новый протокол, сбросить поля
             setConclusion("");
             setNewProtocolId(null);
         }
      };
      Promise.all([loadProtocolInfo(), loadProtocolDetails()])
        .catch((error) => {
          console.error("Ошибка при загрузке данных протокола:", error);
          alert("Ошибка при загрузке данных протокола");
        })
        .finally(() => {
           setIsLoading(false);
        });
    }
  }, [ldoc, nvalue, activeProtocolId, token]);
  const saveData = () => {
    const effectiveProtocolId = newProtocolId || activeProtocolId || 0;
    const formattedDateMeasurement = dateMeasurement ? new Date(dateMeasurement).toISOString() : null;
    const formattedDateProtocol = dateProtocol ? new Date(dateProtocol).toISOString() : null;
    const payload = {
      Id: effectiveProtocolId,
      Name: "Протокол измерений толщины стенки замкнутых элементов",
      ProtocolDate: formattedDateProtocol,
      idMeasuring: getIdByName(selectedMeasurementTool, measurementToolsList),
      idSpecObserver: getIdByName(selectedConductedBy, peopleList),
      idDoc: getIdByName(selectedNormativeDoc, normativeDocsList),
      idPhoto: null,
      ProtocolNum: groupedData["№ протокола"] || "",
      BaseWidth: 0,
      BeltDiameter: 0,
      SchemaNum: 0,
      DateMeasuring: formattedDateMeasurement,
      idSpecExec: getIdByName(selectedDevelopedBy, peopleList),
      AxisRotate: 0,
      LocationDist: "",
      LocationPoints: "",
      DiscrepBetween: "",
      AvgError: "",
      NType: 3,
      // --- Использование Conclusion из состояния ---
      Conclusion: conclusion,
      // --- Использование Conclusion из состояния ---
      RelRollerBelt: 0.8,
      IsAvgValueDevice: false,
      idProject: 456,
      idNormDocuments: getIdByName(selectedNormativeDoc, normativeDocsList)?.toString() || "",
      idMeasurings: getIdByName(selectedMeasurementTool, measurementToolsList)?.toString() || "",
      Gost: selectedNormativeDoc || "",
      IsOutputHide: false,
      Note: "",
      TotalPages: 1,
      IsAllowPlanHeights: true,
      IsWorkNotTech: false,
      LDoc: ldoc
    };
    console.log('Отправляемый payload Thickness Protocol:', payload);
    setIsLoading(true);
    axios.post('/api/protocol/save/', payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        console.log("Ответ от сервера при сохранении Thickness Protocol:", response.data);
        if (!newProtocolId && response.data.protocol_id) {
            const createdProtocolId = response.data.protocol_id;
            console.log("Создан новый протокол Thickness с ID:", createdProtocolId);
            setNewProtocolId(createdProtocolId);
            if (!photoTabProtocolId) {
               setPhotoTabProtocolId(createdProtocolId);
            }
        } else {
            console.log("Обновлен протокол Thickness с ID:", effectiveProtocolId);
        }
        console.log(response.data.message || "Протокол успешно сохранен/обновлен");
        if (refreshProtocols) {
          refreshProtocols();
        }
        alert(response.data.message || "Протокол успешно сохранен/обновлен");
      })
      .catch((error) => {
        console.error("Ошибка сохранения/обновления протокола Thickness:", error);
        alert("Ошибка при сохранении/обновлении протокола: " + (error.response?.data?.message || error.message));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Функции для работы с таблицей
  const handleAddRow = () => {
    const newRow = {
      id: Date.now(),
      sectionNumber: '',
      elementName: '',
      measuredThickness: '',
      deviation: ''
    };
    setTableData([...tableData, newRow]);
  };

  const handleDeleteRow = () => {
    if (tableData.length > 0) {
      const updatedData = [...tableData];
      updatedData.pop();
      setTableData(updatedData);
    }
  };

  const handleInputChange = (id, field, value) => {
    setTableData(tableData.map(row => 
      row.id === id ? { ...row, [field]: value } : row
    ));
  };

  return (
    <CCard className="mb-4">
      {isLoading && (
        <div className="text-center p-3">
          <CSpinner size="sm" />
          <span className="ms-2">Загрузка/Сохранение данных...</span>
        </div>
      )}
      <CCardBody>
        <CNav variant="tabs" role="tablist">
          <CNavItem>
            <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>Сведения</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>Результаты измерений</CNavLink>
          </CNavItem>
          {/* --- Вкладка 3: Вывод --- */}
          <CNavItem>
            <CNavLink active={activeKey === 3} onClick={() => setActiveKey(3)}>Вывод</CNavLink>
          </CNavItem>
          {/* --- Вкладка 3: Вывод --- */}
          <CNavItem>
            <CNavLink active={activeKey === 4} onClick={() => setActiveKey(4)}>Фото измерений</CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          {/* Вкладка "Сведения" */}
          <CTabPane visible={activeKey === 1}>
            <CTable borderless>
              <CTableBody>
                {["Объект", "Адрес объекта", "Основание для проведения измерений", "Цель измерений"].map((key, idx) => (
                  <CTableRow key={idx}>
                    <CTableDataCell className="fw-bold" style={{ width: "30%" }}>{key}</CTableDataCell>
                    <CTableDataCell>
                      <CFormInput value={groupedData[key] || ""} readOnly />
                    </CTableDataCell>
                  </CTableRow>
                ))}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Нормативные документы
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedNormativeDoc}
                      onChange={(e) => setSelectedNormativeDoc(e.target.value)}
                      disabled={normativeDocs.length === 0}
                    >
                      {normativeDocs.length > 0 ? (
                        normativeDocs.map((doc, idx) => (
                          <option key={idx} value={doc}>
                            {doc}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Средства измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedMeasurementTool}
                      onChange={(e) => setSelectedMeasurementTool(e.target.value)}
                      disabled={measurementToolsOptions.length === 0}
                    >
                      {measurementToolsOptions.length > 0 ? (
                        measurementToolsOptions.map((tool, idx) => (
                          <option key={idx} value={tool}>
                            {tool}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Измерения проводил
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedConductedBy}
                      onChange={(e) => setSelectedConductedBy(e.target.value)}
                      disabled={measurementConductedByOptions.length === 0}
                    >
                      {measurementConductedByOptions.length > 0 ? (
                        measurementConductedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата проведения измерений
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormInput
                      type="date"
                      value={dateMeasurement}
                      onChange={(e) => setDateMeasurement(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                {Object.entries(groupedData).map(([key, value], idx) => {
                  const skipKeys = [
                    "Объект",
                    "Адрес объекта",
                    "Основание для проведения измерений",
                    "Цель измерений",
                    "№ протокола",
                    "Дата проведения измерений",
                    "Дата протокола"
                  ];
                  if (skipKeys.includes(key)) {
                    return null;
                  }
                  return (
                    <CTableRow key={`other-${idx}`}>
                      <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                        {key}
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput value={value || ""} readOnly />
                      </CTableDataCell>
                    </CTableRow>
                  );
                })}
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Дата протокола
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormInput
                      type="date"
                      value={dateProtocol}
                      onChange={(e) => setDateProtocol(e.target.value)}
                    />
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="fw-bold" style={{ width: "30%" }}>
                    Разработал
                  </CTableDataCell>
                  <CTableDataCell>
                    <CFormSelect
                      value={selectedDevelopedBy}
                      onChange={(e) => setSelectedDevelopedBy(e.target.value)}
                      disabled={developedByOptions.length === 0}
                    >
                      {developedByOptions.length > 0 ? (
                        developedByOptions.map((person, idx) => (
                          <option key={idx} value={person}>
                            {person}
                          </option>
                        ))
                      ) : (
                        <option value="">Нет данных</option>
                      )}
                    </CFormSelect>
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CTabPane>
          {/* Вкладка "Результаты измерений" */}
          <CTabPane visible={activeKey === 2}>
            <div className="mb-3">
              <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                <CButton color="secondary" onClick={handleAddRow}>Добавить</CButton>
                <CButton color="secondary" onClick={handleDeleteRow}>Удалить</CButton>
                <span className="ms-4 fw-bold">Элемент</span>
                <CFormSelect style={{ width: "180px" }}>
                  <option>Пояс</option>
                  <option>Раскос</option>
                  <option>Распорка</option>
                  <option>Шпренгель</option>
                  <option>Стойка</option>
                </CFormSelect>
                <span className="ms-4 fw-bold">Диаметр трубы по проекту, мм</span>
                <CFormInput style={{ width: "150px" }} />
                <span className="ms-4 fw-bold">Толщина элемента по проекту, мм</span>
                <CFormInput 
                  style={{ width: "150px" }} 
                  value={projectThickness}
                  onChange={(e) => setProjectThickness(e.target.value)}
                />
              </div>
              
              <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                <span className="fw-bold">ГОСТ:</span>
                <CInputGroup style={{ width: "250px" }}>
                  <CFormInput
                    value={gostValue}
                    onChange={(e) => setGostValue(e.target.value)}
                    placeholder="Введите ГОСТ"
                  />
                  <CButton
                    type="button"
                    color="primary"
                    variant="outline"
                    onClick={() => console.log('Открыть модальное окно выбора ГОСТ')}
                    style={{ maxHeight: '38px' }}
                  >
                    <CIcon icon={cilPlus} />
                  </CButton>
                </CInputGroup>
                <span className="ms-4 fw-bold">Проект:</span>
                <CInputGroup style={{ width: "250px" }}>
                  <CFormInput
                    value={projectValue}
                    onChange={(e) => setProjectValue(e.target.value)}
                    placeholder="Введите проект"
                  />
                  <CButton
                    type="button"
                    color="primary"
                    variant="outline"
                    onClick={() => console.log('Открыть модальное окно выбора проекта')}
                    style={{ maxHeight: '38px' }}
                  >
                    <CIcon icon={cilPlus} />
                  </CButton>
                </CInputGroup>
              </div>
            </div>
            
            <CTable bordered>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell>№ секции</CTableHeaderCell>
                  <CTableHeaderCell>Наименование элемента, мм</CTableHeaderCell>
                  <CTableHeaderCell>Измеренная толщина стенки трубы, мм</CTableHeaderCell>
                  <CTableHeaderCell>Отклонение, %</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {tableData.length > 0 ? (
                  tableData.map((row) => (
                    <CTableRow key={row.id}>
                      <CTableDataCell>
                        <CFormInput
                          value={row.sectionNumber}
                          onChange={(e) => handleInputChange(row.id, 'sectionNumber', e.target.value)}
                        />
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput
                          value={row.elementName}
                          onChange={(e) => handleInputChange(row.id, 'elementName', e.target.value)}
                        />
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput
                          value={row.measuredThickness}
                          onChange={(e) => handleInputChange(row.id, 'measuredThickness', e.target.value)}
                        />
                      </CTableDataCell>
                      <CTableDataCell>
                        <CFormInput
                          value={row.deviation}
                          onChange={(e) => handleInputChange(row.id, 'deviation', e.target.value)}
                        />
                      </CTableDataCell>
                    </CTableRow>
                  ))
                ) : (
                  <CTableRow>
                    <CTableDataCell colSpan="4" className="text-center">
                      Нет данных
                    </CTableDataCell>
                  </CTableRow>
                )}
              </CTableBody>
            </CTable>
          </CTabPane>
          {/* --- Вкладка 3: Вывод --- */}
          <CTabPane visible={activeKey === 3}>
            <CFormTextarea
              rows={8}
              placeholder="Введите вывод по результатам измерений..."
              value={conclusion}
              onChange={(e) => setConclusion(e.target.value)}
            />
          </CTabPane>
          {/* --- Вкладка 3: Вывод --- */}
          {/* Вкладка "Фото измерений" */}
          <CTabPane visible={activeKey === 4}>
            {photoTabProtocolId ? (
              <PhotoTab idProtocol={photoTabProtocolId} />
            ) : (
              <div className="text-center text-muted">
                Для добавления фото необходимо сначала сохранить протокол.
              </div>
            )}
          </CTabPane>
        </CTabContent>
        <div className="d-flex justify-content-end gap-3 mt-auto pt-4">
          <CButton color="secondary" onClick={() => {/* Логика отмены */ }}>
            Отменить
          </CButton>
          <CButton color="success" onClick={saveData} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </CButton>
        </div>
      </CCardBody>
    </CCard>
  );
};
export default ProtocolThickness;